import { FALLBACK_ROUTES, FallbackRoute, UNCERTAIN_REPLY_PHRASES } from '../config/fallbackRoutes';

function normalize(text: string): string {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

/** Devuelve la primera ruta cuyo keyword aparece en el texto, o null si ninguna calza. */
export function matchFallbackRoute(text: string): FallbackRoute | null {
  const normalized = normalize(text ?? '');
  if (!normalized) return null;
  for (const route of FALLBACK_ROUTES) {
    if (route.keywords.some(k => normalized.includes(normalize(k)))) return route;
  }
  return null;
}

/** True si la respuesta del asistente suena a "no tengo datos suficientes" (regla 2 del prompt). */
export function isUncertainReply(reply: string): boolean {
  const normalized = normalize(reply ?? '');
  return UNCERTAIN_REPLY_PHRASES.some(p => normalized.includes(normalize(p)));
}
